import { Tabs, Image } from 'antd'

// import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

import bigdata from '../../assets/images/production/bigdata.png'
import electronic from '../../assets/images/production/electronic.png'
import analyze from '../../assets/images/production/analyze.png'
import operate from '../../assets/images/production/operate.png'

import xinggui from '../../assets/images/production/xinggui.png'
import xinghui from '../../assets/images/production/xinghui.png'
import xingmeng from '../../assets/images/production/xingmeng.png'
import xingqu from '../../assets/images/production/xingqu.png'

import BigData from './BigData'
import DataGovernance from './DataGovernance'
import AnalyticalModelingTools from './AnalyticalModelingTools'
import ApplicationDevelopmentTools from './ApplicationDevelopmentTools'
import FengSeries from './FengSeries'
import YingSeries from './YingSeries'
import ComprehensiveForensicsSeries from './ComprehensiveForensicsSeries'
import ForensicAnalysisSeries from './ForensicAnalysisSeries'
import DataAnalysisService from './DataAnalysisService'
import DataOperationService from './DataOperationService'

import styles from './index.module.scss'

import { useEffect, useState } from 'react'

import { urlParams } from 'utils/urlParams';
import { useHistory } from 'react-router-dom'

import { TOOLS } from 'constantss'

const toolList = [
    {
        src: xingqu,
        title: 'FH-FDP',
        desc: '“星渠”数据迁移工具',
        href: TOOLS.FDP_URL
    },
    {
        src: xingmeng,
        title: 'FH-FitBI',
        desc: '“星梦”商业智能工具',
        href: TOOLS.BI_URL
    },
    {
        src: xinggui,
        title: 'FH-FitACE',
        desc: '“星轨”低代码开发平台',
        href: TOOLS.ACE_URL
    },
    {
        src: xinghui,
        title: 'FH-FitBOSS',
        desc: '“星绘”数据可视化平台',
        href: TOOLS.BOSS_URL
    }
];

const tabContent = (content, key, item) => (
    <div className={styles['production-item']} key={key}>
        <div className={styles['production-content']}>{content}</div>
        <div className={styles['see-detail']} onClick={() => {
            // if(productionObj[item.key][key] !== 'ApplicationDevelopmentTools') {
                window.open(`${window.location.origin}/production?module=${productionObj[item.key][key]}`, '_blank')
            // } else {
            //     window.open(TOOLS.URL, '_black');
            // }
        }}>了解更多 <div className={styles['arrow']}></div></div>
    </div>
)

const productionObj = {
    'BigData': ['BigDataPlatform', 'DataGovernanceTools', 'AnalyticalModelingTools', 'ApplicationDevelopmentTools'],
    'ElectronicForensicsProducts': ['FengSeries', 'YingSeries', 'ComprehensiveForensicsSeries', 'ForensicAnalysisSeries'],
    'DataAnalysisService': ['DataAnalysisService'],
    'DataOperationService': ['DataOperationService']
};

const productionList = [
  {
    key: 'BigData',
    label: (
      <div className={styles['production-label']}>
        <img src={bigdata} alt="" />
        <span>大数据智能化产品</span>
      </div>
    ),
    content: [
      <div>
        <div>大数据平台</div>
        <p>
          将大数据能力与容器化云平台进行深度整合，融合多元算力，大幅提升资源利用率，提供统一集中的租户管理及统一运营，实现全栈集成运管和调度
        </p>
      </div>,
      <div>
        <div>数据治理工具</div>
        <p>
          以面向业务的专项治理为导向，构建覆盖从数据接入、数据处理、数据组织、数据治理到数据服务全流程的数据资源体系
        </p>
      </div>,
      <div>
        <div>分析建模工具</div>
        <p>
          立足于不同的业务分析场景，实现传统业务思路向数据分析模型的轻松转化，助力各行业数据价值的快速变现
        </p>
      </div>,
      <div>
        <div>应用开发工具</div>
        {/* <p>作为各个工具的数据存储载体， 从数据和业务流程两个核心维度出发，贯穿数据定义、业务流程编排、数据分析、应用构建全流程；实现工具集间流程贯连，数据互联，自动智能，协助共享</p> */}
        <p>可视化大屏开发工具-BOSS</p>
        <p>智能低代码开发工具-ACE</p>
      </div>
    ]
  },
  {
    key: 'ElectronicForensicsProducts',
    label: (
      <div className={styles['production-label']}>
        <img src={electronic} alt="" />
        <span>电子取证产品</span>
      </div>
    ),
    content: [
      <div>
        <div>“烽”系列</div>
        <p>
          该系列产品主要针对涉案和违法犯罪嫌疑人持有的移动智能终端设备等进行数据采集的产品
        </p>
      </div>,
      <div>
        <div>“鹰”系列</div>
        <p>
          该系列产品是一款集电子数据证据地提取、解析、固定、分析、展示、报告生成为一体的取证产品
        </p>
      </div>,
      <div>
        <div>综合取证系列</div>
        <p>
          该系列产品运用多作业并行处理的工作台设计理念，融合手机、硬盘、计算机等多介质取证能力于一体
        </p>
      </div>,
      <div>
        <div>取证分析系列</div>
        <p>
          “辰星”智能取证分析平台是一款电子取证数据的综合业务应用平台
        </p>
      </div>
    ]
  },
  {
    key: 'DataAnalysisService',
    label: (
      <div className={styles['production-label']}>
        <img src={analyze} alt="" />
        <span>数据分析服务</span>
      </div>
    ),
    content: [
      <div>
        <div>数据分析服务</div>
        <p>
          由数据分析团队为用户提供专业的一线数据分析服务，充分赋能数据深度分析、专项建模、专题研究等工作场景。团队成员包括数据科学家、算法工程师、数据分析师，其中博士、硕士占比70%以上
        </p>
      </div>
    ]
  },
  {
    key: 'DataOperationService',
    label: (
      <div className={styles['production-label']}>
        <img src={operate} alt="" />
        <span>数据运营服务</span>
      </div>
    ),
    content: [
      <div>
        <div>数据运营服务</div>
        <p>
          以专业化的数据技术，分解从数据到服务的每一个步骤，将场景要素、资产价值、业务需要三元素紧密结合，推出专精的智能数字管理工具，高度匹配各行业领域客户需要，并且为用户配备定制化全周期运营服务，覆盖全国25+城市
        </p>
      </div>
    ]
  }
]

function Production() {

    const [type, setType] = useState('');
    const [module, setModule] = useState('');

    const history = useHistory();

    useEffect(() => {
        setModule(urlParams.getUrlParams('module'));
        setType(urlParams.getUrlParams('type'));
    }, [])

    useEffect(() => {
        const unlisten = history.listen((historyLocation) => {
            setModule(urlParams.getUrlParams('module'));
            setType(urlParams.getUrlParams('type'));
        })
        return () => {
            unlisten();
        }
    }, [history]);

    return module === 'BigDataPlatform' ? <BigData /> :
        module === 'DataGovernanceTools' ? <DataGovernance /> :
            module === 'AnalyticalModelingTools' ? <AnalyticalModelingTools /> :
                module === 'ApplicationDevelopmentTools' ? <ApplicationDevelopmentTools /> :
                    module === 'FengSeries' ? <FengSeries /> :
                        module === 'YingSeries' ? <YingSeries /> :
                            module === 'ComprehensiveForensicsSeries' ? <ComprehensiveForensicsSeries /> :
                                module === 'ForensicAnalysisSeries' ? <ForensicAnalysisSeries /> :
                                    module === 'DataAnalysisService' ? <DataAnalysisService /> :
                                        module === 'DataOperationService' ? <DataOperationService /> : (
                                            <div className={styles['production-wrapper']}>
                                                <div className={styles['banner']}>
                                                    <div className={styles['title']}>产品及服务</div>
                                                    <div className={styles['content']}>贯穿数据全生命周期，释放数据价值，为行业应用提供技术支撑。</div>
                                                    {/* <div className={styles['tool-wrapper']}>
                                                        <div className={styles['tool-content']}>
                                                            {toolList.map((item, index) => (
                                                                <div className={styles['tool-item']} key={index}>
                                                                    <Image src={item.src} preview={false} />
                                                                    <div className={styles['tool-right']}>
                                                                        <span className={styles['tool-title']} onClick={() => {
                                                                            window.open(item.href, '_blank');
                                                                        }}>{item.title}</span>
                                                                        <span className={styles['tool-desc']}>{item.desc}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div> */}
                                                </div>
                                                <div className={styles['production-container']}>
                                                    {/* <StyleProvider
                                                        hashPriority='high'
                                                        transformers={[legacyLogicalPropertiesTransformer]}
                                                    > */}
                                                    <Tabs
                                                        defaultActiveKey={type || 'BigData'}
                                                        activeKey={type || 'BigData'}
                                                        centered
                                                        destroyInactiveTabPane
                                                        items={productionList.map((item) => (
                                                            {
                                                                label: item.label,
                                                                key: item.key,
                                                                children: item.content.map((value, key) => tabContent(value, key, item))
                                                            }
                                                        ))}
                                                        onChange={(key) => {
                                                            setType(key)
                                                        }}
                                                    />
                                                    {/* </StyleProvider> */}
                                                </div>
                                            </div>
                                        )
}

export default Production